(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["discount-tab"] && !Shopify.designMode) return;
  try {
    function parseKlaviyoFormId(value) {
    const raw = (value || '').trim();
    if (!raw) return '';

    if (/^[A-Za-z0-9]{6}$/.test(raw)) return raw;

    const segments = raw.split(/[/?#]/).filter(Boolean);
    const last = segments[segments.length - 1] || '';
    if (/^[A-Za-z0-9]{6}$/.test(last)) return last;

    return raw;
  }

  function openKlaviyoForm(formId) {
    if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(formId);
      return 'api';
    }

    if (window._klOnsite && typeof window._klOnsite.openForm === 'function') {
      window._klOnsite.openForm([formId]);
      return 'api';
    }

    window._klOnsite = window._klOnsite || [];
    if (Array.isArray(window._klOnsite)) {
      const queued = window._klOnsite.some(function (item) {
        return Array.isArray(item) && item[0] === 'openForm' && item[1] === formId;
      });
      if (!queued) window._klOnsite.push(['openForm', formId]);
    }

    return 'queue';
  }

  function handleDiscountTabClick(event) {
    const tab = event.target.closest('discount-tab');
    if (!tab) return;

    const formId = parseKlaviyoFormId(tab.dataset.klaviyoFormId);
    if (!formId) return;

    event.preventDefault();
    if (openKlaviyoForm(formId) === 'api') return;

    let attempts = 0;
    const interval = setInterval(() => {
      attempts += 1;
      if (openKlaviyoForm(formId) === 'api' || attempts >= 20) {
        clearInterval(interval);
      }
    }, 250);
  }

  function setDiscountTabScrollbarOffset() {
    const tab = document.querySelector('discount-tab');
    if (!tab) return;

    const desktop = window.matchMedia('(min-width: 990px)').matches;
    const scroller = desktop
      ? document.querySelector('.page-wrapper')
      : document.scrollingElement || document.documentElement;

    if (!scroller) {
      tab.style.setProperty('--discount-tab-right', '15px');
      return;
    }

    const classicWidth = scroller.offsetWidth - scroller.clientWidth;
    const hasOverflow = scroller.scrollHeight > scroller.clientHeight;
    const overlayWidth = hasOverflow && classicWidth === 0 ? 15 : 0;
    tab.style.setProperty('--discount-tab-right', `${classicWidth || overlayWidth}px`);
  }

  if (!customElements.get('discount-tab')) {
    customElements.define('discount-tab', class extends HTMLElement {});
  }

  document.addEventListener('click', handleDiscountTabClick);
  // window.addEventListener('resize', setDiscountTabScrollbarOffset);
  // setDiscountTabScrollbarOffset();
  } catch(e) { console.error(e); }
})();

})();
